import { defineComponent as b, createElementBlock as c, openBlock as d, toDisplayString as m, ref as $, createElementVNode as o, createVNode as l, createBlock as x, unref as s, withCtx as a, createTextVNode as _, resolveComponent as z, createCommentVNode as w, onMounted as F, Fragment as S, renderList as H } from "vue";
import { IonPage as k, IonContent as I, IonHeader as C, IonToolbar as P, IonButtons as D, IonBackButton as j, IonTitle as R, IonButton as T, IonFab as K, IonFabButton as W, IonIcon as Z } from "@ionic/vue";
import G from "axios";
const J = /* @__PURE__ */ b({
  __name: "ErrorCaption",
  props: {
    error: {}
  },
  setup(e) {
    return (n, t) => (d(), c("div", null, m(e.error), 1));
  }
}), Q = { class: "mt-4 flex flex-col" }, X = ["data-testid", "for"], Y = ["id", "data-testid", "value"], ze = /* @__PURE__ */ b({
  __name: "TextField",
  props: {
    label: {},
    field: {},
    value: {},
    validator: { type: Function }
  },
  emits: ["update", "error"],
  setup(e, { emit: n }) {
    const t = $(""), i = n;
    function u(f) {
      const y = f.target.value;
      if (i("update", { [e.field]: y }), e.validator) {
        const g = e.validator({ value: y });
        t.value = "", g.code && (i("error", `${e.field}:${g.code}`), g.message && (t.value = g.message(e.field)));
      }
    }
    return (f, y) => (d(), c("div", Q, [
      o("label", {
        "data-testid": e.field + "-label",
        for: e.field
      }, m(e.label), 9, X),
      o("input", {
        id: e.field,
        "data-testid": e.field + "-input",
        value: e.value,
        class: "border",
        onInput: u
      }, null, 40, Y),
      l(J, {
        "data-testid": `${e.field}:error`,
        error: t.value
      }, null, 8, ["data-testid", "error"])
    ]));
  }
}), O = /* @__PURE__ */ b({
  __name: "HomeView",
  setup(e) {
    return (n, t) => (d(), x(s(k), null, {
      default: a(() => [
        l(s(I), { fullscreen: !0 }, {
          default: a(() => [...t[0] || (t[0] = [
            o("div", { class: "container" }, [
              o("h1", null, "Welcome to Idem Mobile"),
              o("p", null, "This is a shared component used by both web and mobile apps.")
            ], -1)
          ])]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), E = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [i, u] of n)
    t[i] = u;
  return t;
}, Fe = /* @__PURE__ */ E(O, [["__scopeId", "data-v-e5a7a958"]]), ee = /* @__PURE__ */ b({
  __name: "ProfileView",
  setup(e) {
    return (n, t) => (d(), x(s(k), null, {
      default: a(() => [
        l(s(C), null, {
          default: a(() => [
            l(s(P), null, {
              default: a(() => [
                l(s(D), { slot: "start" }, {
                  default: a(() => [
                    l(s(j), { "default-href": "/eventos" })
                  ]),
                  _: 1
                }),
                l(s(R), null, {
                  default: a(() => [...t[0] || (t[0] = [
                    _("Profile", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        l(s(I), { fullscreen: !0 }, {
          default: a(() => [...t[1] || (t[1] = [
            o("div", { class: "container" }, [
              o("h1", null, "Profile"),
              o("p", null, "Profile management coming soon...")
            ], -1)
          ])]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Se = /* @__PURE__ */ E(ee, [["__scopeId", "data-v-6e65d5e7"]]), te = {};
function ne(e, n) {
  const t = z("router-view");
  return d(), x(t);
}
const He = /* @__PURE__ */ E(te, [["render", ne]]), oe = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M256 112v288M400 256H112' class='ionicon-fill-none ionicon-stroke-width'/></svg>", q = typeof import.meta < "u" && "https://idem.belote.family" || "/api";
let v;
try {
  v = G.create({
    baseURL: q,
    timeout: 1e4,
    headers: {
      "Content-Type": "application/json"
    }
  }), typeof globalThis < "u" && globalThis.window && globalThis.window.__IDEM_API_URL__ && (v.defaults.baseURL = globalThis.window.__IDEM_API_URL__), v && v.defaults && (v.defaults.withCredentials = !0);
} catch {
  v = {
    get: () => Promise.reject(new Error("axios not available")),
    post: () => Promise.reject(new Error("axios not available")),
    put: () => Promise.reject(new Error("axios not available")),
    delete: () => Promise.reject(new Error("axios not available")),
    defaults: {
      baseURL: q,
      withCredentials: !0
    },
    interceptors: {
      request: { use: () => {
      } },
      response: { use: () => {
      } }
    }
  };
}
v && v.interceptors && (v.interceptors.request.use(
  (e) => {
    var n;
    return console.log(`API Request: ${(n = e.method) == null ? void 0 : n.toUpperCase()} ${e.url}`), e;
  },
  (e) => (console.error("API Request Error:", e), Promise.reject(e))
), v.interceptors.response.use(
  (e) => e,
  (e) => {
    var n;
    return console.error("API Response Error:", ((n = e.response) == null ? void 0 : n.data) || e.message), Promise.reject(e);
  }
));
const Ke = v, se = { class: "group relative overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition hover:shadow-md" }, le = { class: "flex h-64 flex-col p-5" }, ae = { class: "min-h-28" }, re = { class: "flex items-start justify-between gap-3" }, ie = {
  class: "line-clamp-2 text-lg font-semibold text-gray-900 group-hover:text-teal-600",
  "data-testid": "descripcion-evento"
}, de = { class: "flex shrink-0 flex-col items-end gap-1" }, ue = {
  class: "rounded-full bg-teal-50 px-3 py-1 text-xs font-medium text-teal-700",
  "data-testid": "fecha-hora-evento"
}, ce = { class: "px-3 text-xs text-gray-600" }, fe = { class: "mt-2" }, ve = {
  key: 0,
  class: "rounded-full bg-green-50 px-2.5 py-0.5 text-xs font-medium text-green-700"
}, me = { class: "line-clamp-2 min-h-[2.5rem] text-sm text-gray-600" }, ge = {
  class: "font-medium text-gray-900",
  "data-testid": "direccion-evento"
}, M = /* @__PURE__ */ b({
  __name: "Evento",
  props: {
    evento: {}
  },
  setup(e) {
    return (n, t) => {
      const i = z("router-link");
      return d(), c("article", se, [
        o("div", le, [
          o("div", ae, [
            o("div", re, [
              o("h3", ie, m(e.evento.descripcion), 1),
              o("div", de, [
                o("span", ue, m(e.evento.fecha) + " · " + m(e.evento.hora), 1),
                o("span", ce, m(e.evento.cantidadInscritos) + " usuarios inscritos", 1)
              ])
            ]),
            o("div", fe, [
              e.evento.registrado ? (d(), c("span", ve, "Registrado")) : w("", !0)
            ])
          ]),
          o("p", me, [
            t[0] || (t[0] = _(" Dirección: ", -1)),
            o("span", ge, m(e.evento.direccion), 1)
          ]),
          l(i, {
            to: `/eventos/${e.evento.id}`,
            class: "mt-3 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-teal-600 px-3 py-2 text-center text-sm font-medium text-white transition hover:bg-teal-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
          }, {
            default: a(() => [...t[1] || (t[1] = [
              _(" Ver detalles ", -1),
              o("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                class: "h-4 w-4"
              }, [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M10.293 3.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L13.586 10H4a1 1 0 110-2h9.586l-3.293-3.293a1 1 0 010-1.414z",
                  "clip-rule": "evenodd"
                })
              ], -1)
            ])]),
            _: 1
          }, 8, ["to"])
        ])
      ]);
    };
  }
}), _e = {
  key: 0,
  slot: "end",
  class: "flex gap-2"
}, pe = {
  key: 0,
  class: "px-4 py-4 text-center"
}, he = {
  key: 1,
  class: "px-4 py-4"
}, xe = { class: "mb-6" }, be = { key: 0 }, ye = {
  class: "text-2xl font-bold text-gray-900 mb-4",
  "data-testid": "mensaje-bienvenida"
}, we = {
  key: 1,
  "data-testid": "mensaje-bienvenida-sin-usuario",
  class: "mb-4"
}, Ee = {
  key: 0,
  class: "mb-6"
}, $e = {
  class: "text-xl font-bold tracking-tight text-gray-900 mb-4",
  "data-testid": "evento-registrado-titulo"
}, ke = { class: "py-2" }, Ie = {
  key: 1,
  class: "pb-4 text-xl font-bold tracking-tight text-gray-900",
  "data-testid": "lista-eventos-titulo"
}, Ce = {
  key: 2,
  class: "grid grid-cols-1 gap-4"
}, Pe = {
  key: 3,
  class: "rounded-lg border border-dashed border-gray-300 p-10 text-center"
}, Re = /* @__PURE__ */ b({
  __name: "ListaEventos",
  setup(e) {
    const n = "https://idem.belote.family", t = $({ data: [] }), i = $(null), u = $(!1), f = $(!0);
    async function y() {
      var p;
      f.value = !0;
      try {
        console.log("Fetching eventos from:", `${n}/eventos/-33.447915/-70.670447`);
        const r = await v.get("/eventos/-33.447915/-70.670447");
        t.value = r, console.log("Eventos received:", r.data);
      } catch (r) {
        console.error("Error fetching eventos:", r), console.error("Error details:", ((p = r.response) == null ? void 0 : p.data) || r.message), t.value = { data: [] };
      }
      try {
        const r = await v.get("/profile");
        i.value = r, u.value = !0, console.log("Profile loaded:", r.data);
      } catch (r) {
        console.log("Not logged in or profile error:", r.message), u.value = !1;
      }
      f.value = !1;
    }
    F(() => {
      console.log("ListaEventos component mounted, loading data..."), y();
    });
    function g() {
      var p, r;
      switch ((r = (p = i.value) == null ? void 0 : p.data) == null ? void 0 : r.genero) {
        case "M":
          return "o";
        case "F":
          return "a";
        default:
          return "e";
      }
    }
    function L() {
      return t.value.data.every((p) => !p.registrado) ? "Eventos a los que te puedes registrar" : "Otros Eventos a los que te puedes registrar";
    }
    return (p, r) => (d(), x(s(k), null, {
      default: a(() => [
        l(s(C), null, {
          default: a(() => [
            l(s(P), null, {
              default: a(() => [
                l(s(R), null, {
                  default: a(() => [...r[0] || (r[0] = [
                    _("Eventos", -1)
                  ])]),
                  _: 1
                }),
                u.value && !f.value ? (d(), c("div", _e, [
                  l(s(T), {
                    "router-link": "/profile",
                    fill: "clear",
                    size: "small"
                  }, {
                    default: a(() => [...r[1] || (r[1] = [
                      _(" Perfil ", -1)
                    ])]),
                    _: 1
                  }),
                  l(s(T), {
                    "router-link": "/logout",
                    fill: "clear",
                    size: "small"
                  }, {
                    default: a(() => [...r[2] || (r[2] = [
                      _(" Salir ", -1)
                    ])]),
                    _: 1
                  })
                ])) : f.value ? w("", !0) : (d(), x(s(T), {
                  key: 1,
                  "router-link": "/login",
                  slot: "end",
                  fill: "clear",
                  size: "small"
                }, {
                  default: a(() => [...r[3] || (r[3] = [
                    _(" Iniciar Sesión ", -1)
                  ])]),
                  _: 1
                }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        l(s(I), { fullscreen: !0 }, {
          default: a(() => {
            var B, V, U, N;
            return [
              f.value ? (d(), c("div", pe, [...r[4] || (r[4] = [
                o("p", null, "Cargando eventos...", -1)
              ])])) : (d(), c("div", he, [
                o("header", xe, [
                  u.value ? (d(), c("div", be, [
                    o("div", ye, " Bienvenid" + m(g()) + " " + m((V = (B = i.value) == null ? void 0 : B.data) == null ? void 0 : V.nombre), 1)
                  ])) : (d(), c("div", we, [...r[5] || (r[5] = [
                    o("h1", { class: "text-2xl font-bold tracking-tight text-gray-900" }, "Eventos cerca de ti", -1),
                    o("p", { class: "mt-1 text-sm text-gray-500" }, "Explora actividades y experiencias en tu zona.", -1)
                  ])]))
                ]),
                t.value.data.some((h) => h.registrado) ? (d(), c("div", Ee, [
                  o("h2", $e, " Te encuentras registrad" + m(g()) + " como asistente en el siguiente evento: ", 1),
                  o("div", ke, [
                    l(M, {
                      "data-testid": "evento-registrado",
                      evento: t.value.data.find((h) => h.registrado)
                    }, null, 8, ["evento"])
                  ])
                ])) : w("", !0),
                u.value ? (d(), c("h2", Ie, m(L()), 1)) : w("", !0),
                (U = t.value.data) != null && U.length ? (d(), c("div", Ce, [
                  (d(!0), c(S, null, H(t.value.data.filter((h) => !h.registrado), (h) => (d(), x(M, {
                    evento: h,
                    key: h.id,
                    "data-testid": "evento"
                  }, null, 8, ["evento"]))), 128))
                ])) : w("", !0),
                !((N = t.value.data) != null && N.length) && !f.value ? (d(), c("div", Pe, [...r[6] || (r[6] = [
                  o("p", { class: "text-gray-500" }, "No hay eventos disponibles en este momento.", -1)
                ])])) : w("", !0)
              ])),
              l(s(K), {
                vertical: "bottom",
                horizontal: "end",
                slot: "fixed"
              }, {
                default: a(() => [
                  l(s(W), { "router-link": "/eventos/agregar" }, {
                    default: a(() => [
                      l(s(Z), { icon: s(oe) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ];
          }),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), We = /* @__PURE__ */ E(Re, [["__scopeId", "data-v-03a0778e"]]), Ae = { class: "container" }, Le = /* @__PURE__ */ b({
  __name: "DetalleEvento",
  props: {
    id: {}
  },
  setup(e) {
    return (n, t) => (d(), x(s(k), null, {
      default: a(() => [
        l(s(C), null, {
          default: a(() => [
            l(s(P), null, {
              default: a(() => [
                l(s(D), { slot: "start" }, {
                  default: a(() => [
                    l(s(j), { "default-href": "/eventos/lista" })
                  ]),
                  _: 1
                }),
                l(s(R), null, {
                  default: a(() => [...t[0] || (t[0] = [
                    _("Evento Details", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        l(s(I), { fullscreen: !0 }, {
          default: a(() => [
            o("div", Ae, [
              t[1] || (t[1] = o("h1", null, "Evento Details", -1)),
              o("p", null, "Event ID: " + m(e.id), 1),
              t[2] || (t[2] = o("p", null, "Event details coming soon...", -1))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Ze = /* @__PURE__ */ E(Le, [["__scopeId", "data-v-5ff5eb3f"]]), Te = /* @__PURE__ */ b({
  __name: "AgregarEvento",
  setup(e) {
    return (n, t) => (d(), x(s(k), null, {
      default: a(() => [
        l(s(C), null, {
          default: a(() => [
            l(s(P), null, {
              default: a(() => [
                l(s(D), { slot: "start" }, {
                  default: a(() => [
                    l(s(j), { "default-href": "/eventos/lista" })
                  ]),
                  _: 1
                }),
                l(s(R), null, {
                  default: a(() => [...t[0] || (t[0] = [
                    _("Agregar Evento", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        l(s(I), { fullscreen: !0 }, {
          default: a(() => [...t[1] || (t[1] = [
            o("div", { class: "container" }, [
              o("h1", null, "Agregar Evento"),
              o("p", null, "Add event form coming soon...")
            ], -1)
          ])]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Ge = /* @__PURE__ */ E(Te, [["__scopeId", "data-v-c64912bc"]]);
function Je(e) {
  return e.code ? e : !e.value || e.value.trim().length === 0 ? {
    ...e,
    code: "required",
    message: (n) => `${n} is required.`
  } : e;
}
const Qe = (e) => e.code ? e : e.value && e.value.length > 0 && !/^[A-Za-z0-9 ]+$/.test(e.value) ? {
  ...e,
  code: "no-special-characters",
  message: (n) => `${n.replace(/([A-Z])/g, (t) => ` ${t.toLowerCase()}`)} can only contain letters and numbers.`
} : e, Xe = (e) => (n) => n.code ? n : !n.value || n.value.length < e ? {
  ...n,
  code: "too-short",
  message: (t) => `${t} must be at least ${e} characters long.`
} : n, Ye = (e) => (n) => n.value && n.value.length > e ? {
  ...n,
  code: "too-long",
  message: (t) => `${t} length cannot exceed ${e} characters.`
} : n, Oe = (e) => e.code ? e : /\s/.test(e.value) ? {
  ...e,
  code: "no-spaces",
  message: (n) => `${n} cannot contain spaces.`
} : e;
function A(e) {
  return typeof e == "string" ? e.replace(/^0+|[^0-9kK]+/g, "").toUpperCase() : "";
}
function De(e) {
  if (typeof e != "string" || /^0+/.test(e) || !/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(e))
    return !1;
  e = A(e);
  let n = parseInt(e.slice(0, -1), 10), t = 0, i = 1;
  for (; n > 0; )
    i = (i + n % 10 * (9 - t++ % 6)) % 11, n = Math.floor(n / 10);
  return (i > 0 ? "" + (i - 1) : "K") === e.slice(-1);
}
function je(e, n = {
  dots: !0
}) {
  e = A(e);
  let t;
  if (n.dots) {
    t = e.slice(-4, -1) + "-" + e.substr(e.length - 1);
    for (let i = 4; i < e.length; i += 3)
      t = e.slice(-3 - i, -i) + "." + t;
  } else
    t = e.slice(0, -1) + "-" + e.substr(e.length - 1);
  return t;
}
function Be(e) {
  const n = Array.from(A(e), Number);
  if (n.length === 0 || n.includes(NaN))
    throw new Error(`"${e}" as RUT is invalid`);
  const t = 11, u = n.reverse().reduce(
    (y, g, L) => y + g * (L % 6 + 2),
    0
  ), f = t - u % t;
  return f === 10 ? "K" : f === 11 ? "0" : f.toString();
}
var Ve = { validate: De, clean: A, format: je, getCheckDigit: Be };
function et(e) {
  return !e.value || e.code || Ve.validate(e.value) ? e : {
    ...e,
    code: "invalid",
    message: () => "invalid RUT."
  };
}
const tt = (...e) => (n) => e.reduce((t, i) => i(t), n), Ue = [
  {
    path: "/profile",
    name: "Profile",
    component: null
    // Will be replaced
  },
  {
    path: "/eventos",
    name: "Eventos",
    component: null,
    // Will be replaced
    redirect: "/eventos/lista",
    children: [
      {
        path: "agregar",
        name: "AgregarEvento",
        component: null
        // Will be replaced
      },
      {
        path: ":id",
        name: "DetalleEvento",
        component: null
        // Will be replaced
      },
      {
        path: "lista",
        name: "ListaEventos",
        component: null
        // Will be replaced
      }
    ]
  },
  {
    path: "/",
    redirect: "/eventos"
  },
  {
    path: "/login",
    name: "Login",
    component: null
    // Will be replaced
  },
  {
    path: "/logout",
    name: "Logout",
    component: null
    // Will be replaced
  },
  {
    path: "/empresa/link",
    name: "Empresa",
    component: null
  },
  {
    path: "/empresa/evento",
    name: "AgregarEventoEmpresa",
    component: null
  }
];
function nt(e) {
  return Ue.map((n) => {
    const t = { ...n };
    return n.name && e[n.name] && (t.component = e[n.name]), n.children && (t.children = n.children.map((i) => {
      const u = { ...i };
      return i.name && e[i.name] && (u.component = e[i.name]), u;
    })), t;
  });
}
export {
  Ge as AgregarEvento,
  Ze as DetalleEvento,
  J as ErrorCaption,
  M as Evento,
  He as EventosView,
  Fe as HomeView,
  We as ListaEventos,
  Se as ProfileView,
  ze as TextField,
  Ke as apiClient,
  nt as createRoutes,
  tt as pipeu,
  Ue as routeDefinitions,
  Ye as validateMaxLength,
  Xe as validateMinLength,
  Oe as validateNoSpaces,
  Qe as validateNoSpecialCharacters,
  Je as validateRequired,
  et as validateRut
};
